module.exports = __webpack_public_path__ + "static/media/tal.13085f39.png";